import React, { useCallback, useRef, useEffect, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { FiCheck, FiX } from 'react-icons/fi';
import useSWR, { mutate as mutateGlobal } from 'swr';
import * as Yup from 'yup';
import { Form } from '@unform/web';

import getValidationErrors from '../../../utils/getValidationErrors';
import api from '../../../services/api';

import { useToast } from '../../../hooks/toast';

import NavBarMenu from '../../../components/NavbarMenu';
import ContainerBox from '../../../components/ContainerBox';
import { Input, Select } from '../../../components/Form';
import ButtonSave from '../../../components/ButtonPrimaryBlue';
import ButtonCancel from '../../../components/ButtonCancel';

import { ButtonGroup, Wrapper } from './styles';

const CategoriesNewEdit = () => {
  const { data } = useSWR('categories');

  const [id, setId] = useState(null);

  const location = useLocation();

  const history = useHistory();

  const formRef = useRef(null);
  const { addToast } = useToast();

  useEffect(() => {
    if (!location.state) {
      return;
    }

    if (location.state.item.type === 'Produtos') {
      formRef.current.setFieldValue('type', 'p');
    }
    if (location.state.item.type === 'Insumos') {
      formRef.current.setFieldValue('type', 'i');
    }
    if (location.state.item.type === 'Matéria-Prima') {
      formRef.current.setFieldValue('type', 'm');
    }

    setId(location.state.item.id);
  }, [location.state]);

  useEffect(() => {
    const descriptionInput = formRef.current.getFieldRef('description');

    descriptionInput.focus();
  }, []);

  const handleSubmit = useCallback(
    async (dataForm) => {
      try {
        formRef.current.setErrors({});

        const schema = Yup.object().shape({
          description: Yup.string().required('Descrição é obrigatório'),
          type: Yup.string().required('Selecione um tipo'),
        });

        await schema.validate(dataForm, {
          abortEarly: false,
        });

        mutateGlobal(`/categories?page=1`, [...data, dataForm], false);

        await api.post('categories', dataForm);

        addToast({
          type: 'success',
          title: 'Cadastro efetuado com Sucesso',
        });

        history.push('/categories');
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current.setErrors(errors);
          return;
        }

        if (err.response.status === 403) {
          addToast({
            type: 'error',
            description: 'Descrição já cadastrada',
          });
          return;
        }

        addToast({
          type: 'error',
          title: 'Erro no cadastro',
          description: 'Verifique os dados.',
        });
      }
    },
    [addToast, history, data]
  );

  const handleUpdate = useCallback(
    async (dataForm) => {
      try {
        formRef.current.setErrors({});

        const schema = Yup.object().shape({
          description: Yup.string().required('Descrição é obrigatório'),
          type: Yup.string().required('Selecione um tipo'),
        });

        await schema.validate(dataForm, {
          abortEarly: false,
        });
        await api.patch(`categories/${id}`, dataForm);

        mutateGlobal(`categories/${id}`, dataForm);

        addToast({
          title: 'Cadastro alterado com Sucesso',
        });

        history.push('/categories');
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current.setErrors(errors);
          return;
        }

        if (err.response.status === 403) {
          addToast({
            type: 'error',
            description: 'Descrição já cadastrada',
          });
          return;
        }

        addToast({
          type: 'error',
          title: 'Erro no cadastro',
          description: 'Verifique os dados.',
        });
      }
    },
    [addToast, history, id]
  );
  return (
    <>
      <NavBarMenu />

      <ContainerBox
        title={location.state ? 'Alterar Categoria' : 'Cadastro de Categorias'}
        small
      >
        <Form
          initialData={location.state ? location.state.item : {}}
          ref={formRef}
          onSubmit={location.state ? handleUpdate : handleSubmit}
        >
          <Wrapper>
            <Input
              id="description"
              name="description"
              label="Categoria*"
              autoComplete="off"
            />

            <Select label="Tipo de Categoria*" name="type" id="type">
              <option value="">Selecione qual tipo é essa Categoria</option>
              <option value="p">Categoria de PRODUTOS</option>
              <option value="i">Categoria de INSUMOS</option>
              <option value="m">Categoria de MATÉRIAS-PRIMAS</option>
            </Select>
          </Wrapper>
          <ButtonGroup style={{ marginTop: 40 }}>
            <ButtonSave icon={FiCheck}>Salvar</ButtonSave>
            <Link to="/categories">
              <ButtonCancel icon={FiX}>Cancelar</ButtonCancel>
            </Link>
          </ButtonGroup>
        </Form>
      </ContainerBox>
    </>
  );
};

export default CategoriesNewEdit;
